import * as React from "react"
import { batch, useSignal } from "@preact/signals-react"

import { useToast } from "@hooks"
import { ActionButton } from "../../@components"
import { useAdminNewListedForm } from "../../../../@hooks"
import { adminNewListedTableData, adminNewListedSkuMappingData } from "../../../../@signals"


export default function SkipButton({ rowData, isSkuMappingTable }) {
	const { showToast } = useToast()
	const { handleSendToBack } = useAdminNewListedForm(rowData)

	const isLoading = useSignal(false)

	const handleClick = () => showToast.confirm(`Are you sure you want to skip the following ${rowData.productName}`, {
		onSubmit: () => {
			isLoading.value = true
			handleSendToBack({ skip: true, qa: true, validated: true }, {
				onSuccess: () => batch(() => {
					isLoading.value = false
					if (!isSkuMappingTable)
						adminNewListedTableData.value = adminNewListedTableData.value.filter(row => row.id !== rowData.id)
					else
						adminNewListedSkuMappingData.value = adminNewListedSkuMappingData.value.filter(row => row.id !== rowData.id)
				}),
				onFinish: () => isLoading.value = false
			})
		},

	})

	return <ActionButton
		isLoading={isLoading.value}
		label="Skip"
		icon="forward"
		onClick={handleClick}
	/>
}